<template>
  <div v-if="postDetail" class="createPostBtnWrapper">
    <v-container style="max-width: 880px">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="wrapperBox">
            <v-col cols="12" class="d-flex justity-start">
              <v-btn
                depressed
                color="primary"
                class="my-4 mr-10"
                @click="backComunity()"
              >
                <v-icon size="18">far fa-left-long</v-icon>
              </v-btn>
              <h4 class="primary--text text-h5 text-center py-4">
                {{ postDetail.title }}
              </h4>
            </v-col>

            <v-col cols="12">
              <DiscussionPost :item="postDetail" @onData="onData" />
            </v-col>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <ModifyPost
      ref="dialogModifyPost"
      @postCreated="handlePostCreated"
      @postUpdated="handlePostUpdated"
      :postType="POST_TYPE_DISCUSSION"
    />
    <v-container v-if="dataEmpty" style="max-width: 880px;">
      <v-card class="postContent pa-5">
        <translate>The discussion is not longer available</translate>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PostService from "@/services/PostService";
import DiscussionPost from "@/components/Post/Discussion/Post";
import ModifyPost from "@/components/Post/ModifyPost.vue";
export default {
  name: "CommunityDetail",
  components: { DiscussionPost, ModifyPost },
  async created() {
    if (this.$route.params.id) {
      const post = await PostService.getPostDetail({filter_id: this.$route.params.id});
      if (post) {
        if (post.list.length !== 0) {
          this.postDetail = post.list[0];
        } else {
          this.dataEmpty = true
        }
      }
    }
  },
  data() {
    return {
      postDetail: {},
      dataEmpty: false
    };
  },
  methods: {
    backComunity() {
      this.$router.push({ name: "community" }).catch((err) => {});
    },
    onData(item) {
      if (item.mode === "update") {
        delete item.mode;
        this.postDetail = { ...this.postDetail, ...item };
      }
      return;
    },
    handlePostCreated() {
      this.backComunity();
    },
    handlePostUpdated(updatedPost) {
      this.postDetail = { ...this.postDetail, ...updatedPost };
    },
  },
};
</script>
<style lang="scss">
.discussion-box {
  position: relative;
  .discussion-cmenu {
    position: absolute;
    top: 0;
    right: 32px;
  }
}
</style>

